// components/AdminLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import AdminRoute from "./AdminRoute"; // Or however you protect admin routes
import Layout from "./Layout";

export default function AdminLayout() {
  return (
    <AdminRoute>
      <Layout>
        <Outlet />
      </Layout>
    </AdminRoute>
  );
}
